export default __webpack_public_path__ + "static/media/social.fddc0c08.svg";